var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E2DE",
    fillRule: "evenodd",
    d: "M7.073 11.918c.76 0 1.492.12 2.179.342A7.008 7.008 0 016.927 7.04C6.927 3.152 10.094 0 14 0c3.906 0 7.073 3.152 7.073 7.041 0 2.07-.897 3.93-2.325 5.219a7.095 7.095 0 012.179-.342c3.906 0 7.073 3.152 7.073 7.04C28 22.849 24.833 26 20.927 26A7.068 7.068 0 0114 20.389 7.067 7.067 0 017.073 26C3.167 26 0 22.848 0 18.959c0-3.889 3.167-7.041 7.073-7.041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClub);
export default __webpack_public_path__ + "static/media/club.cee97e0f658c6828bc8627fa4b8e3545.svg";
export { ForwardRef as ReactComponent };